// Configuração centralizada do Strapi
const PRODUCTION_URL = 'https://www.car.iat.pr.gov.br/cms'
const LOCAL_URL = 'http://localhost:1337'

// Função para detectar se estamos em desenvolvimento local
function isLocalDevelopment(): boolean {
  return window.location.hostname === 'localhost' && 
         (window.location.port === '3000' || window.location.port === '')
}

// Determina qual URL usar baseado no ambiente
export const STRAPI_URL = isLocalDevelopment() ? LOCAL_URL : PRODUCTION_URL
export const STRAPI_API_URL = `${STRAPI_URL}/api`

// Função utilitária para construir URLs de arquivos
export const buildFileUrl = (fileUrl: string): string => {
  if (!fileUrl) return ''

  // Se a URL já começa com http, retorna como está
  if (fileUrl.startsWith('http')) return fileUrl

  // Se começa com /, concatena diretamente
  if (fileUrl.startsWith('/')) return `${STRAPI_URL}${fileUrl}`

  // Caso contrário, adiciona / entre as URLs
  return `${STRAPI_URL}/${fileUrl}`
} 